import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this principle you can listen to the effect of age and gender by comparing two filters. The effect can also be seen by comparing the two graphs",
  theory: theory,
  layout: {
    type: "custom020501",
    options: {
      data: {
        female: {
          whiteNoise: {
            20: `${config.ASSETS_URL}/02/05/principle/white-noise-female-20.mp3`,
            25: `${config.ASSETS_URL}/02/05/principle/white-noise-female-25.mp3`,
            30: `${config.ASSETS_URL}/02/05/principle/white-noise-female-30.mp3`,
            35: `${config.ASSETS_URL}/02/05/principle/white-noise-female-35.mp3`,
            40: `${config.ASSETS_URL}/02/05/principle/white-noise-female-40.mp3`,
            45: `${config.ASSETS_URL}/02/05/principle/white-noise-female-45.mp3`,
            50: `${config.ASSETS_URL}/02/05/principle/white-noise-female-50.mp3`,
            55: `${config.ASSETS_URL}/02/05/principle/white-noise-female-55.mp3`,
            60: `${config.ASSETS_URL}/02/05/principle/white-noise-female-60.mp3`,
            65: `${config.ASSETS_URL}/02/05/principle/white-noise-female-65.mp3`,
            70: `${config.ASSETS_URL}/02/05/principle/white-noise-female-70.mp3`,
          },
          classical: {
            20: `${config.ASSETS_URL}/02/05/principle/classical-female-20.mp3`,
            25: `${config.ASSETS_URL}/02/05/principle/classical-female-25.mp3`,
            30: `${config.ASSETS_URL}/02/05/principle/classical-female-30.mp3`,
            35: `${config.ASSETS_URL}/02/05/principle/classical-female-35.mp3`,
            40: `${config.ASSETS_URL}/02/05/principle/classical-female-40.mp3`,
            45: `${config.ASSETS_URL}/02/05/principle/classical-female-45.mp3`,
            50: `${config.ASSETS_URL}/02/05/principle/classical-female-50.mp3`,
            55: `${config.ASSETS_URL}/02/05/principle/classical-female-55.mp3`,
            60: `${config.ASSETS_URL}/02/05/principle/classical-female-60.mp3`,
            65: `${config.ASSETS_URL}/02/05/principle/classical-female-65.mp3`,
            70: `${config.ASSETS_URL}/02/05/principle/classical-female-70.mp3`,
          },
        },
        male: {
          whiteNoise: {
            20: `${config.ASSETS_URL}/02/05/principle/white-noise-male-20.mp3`,
            25: `${config.ASSETS_URL}/02/05/principle/white-noise-male-25.mp3`,
            30: `${config.ASSETS_URL}/02/05/principle/white-noise-male-30.mp3`,
            35: `${config.ASSETS_URL}/02/05/principle/white-noise-male-35.mp3`,
            40: `${config.ASSETS_URL}/02/05/principle/white-noise-male-40.mp3`,
            45: `${config.ASSETS_URL}/02/05/principle/white-noise-male-45.mp3`,
            50: `${config.ASSETS_URL}/02/05/principle/white-noise-male-50.mp3`,
            55: `${config.ASSETS_URL}/02/05/principle/white-noise-male-55.mp3`,
            60: `${config.ASSETS_URL}/02/05/principle/white-noise-male-60.mp3`,
            65: `${config.ASSETS_URL}/02/05/principle/white-noise-male-65.mp3`,
            70: `${config.ASSETS_URL}/02/05/principle/white-noise-male-70.mp3`,
          },
          classical: {
            20: `${config.ASSETS_URL}/02/05/principle/classical-male-20.mp3`,
            25: `${config.ASSETS_URL}/02/05/principle/classical-male-25.mp3`,
            30: `${config.ASSETS_URL}/02/05/principle/classical-male-30.mp3`,
            35: `${config.ASSETS_URL}/02/05/principle/classical-male-35.mp3`,
            40: `${config.ASSETS_URL}/02/05/principle/classical-male-40.mp3`,
            45: `${config.ASSETS_URL}/02/05/principle/classical-male-45.mp3`,
            50: `${config.ASSETS_URL}/02/05/principle/classical-male-50.mp3`,
            55: `${config.ASSETS_URL}/02/05/principle/classical-male-55.mp3`,
            60: `${config.ASSETS_URL}/02/05/principle/classical-male-60.mp3`,
            65: `${config.ASSETS_URL}/02/05/principle/classical-male-65.mp3`,
            70: `${config.ASSETS_URL}/02/05/principle/classical-male-70.mp3`,
          },
        },
      },
    },
  },
};

export default principle;
